import Image from 'next/image'
import { LogoContainer } from './styled'

const Logo = ({ image, alt }: { image: string; alt: string }) => {
  return (
    <LogoContainer>
      <Image src={image} layout="fill" objectFit="contain" alt={alt} />
    </LogoContainer>
  )
}

export default Logo
